import { render, staticRenderFns } from "./BadgeLight.vue?vue&type=template&id=5cf3303c&"
import script from "./BadgeLight.vue?vue&type=script&lang=js&"
export * from "./BadgeLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports